export const GENERATED_DOCUMENT_NUMBER_PREFIX = "NO-NUMBER-";

export const NO_NUMBER_ON_BILL_LABEL = "No number on bill";
export const NO_FACILITY_LABEL = "No facility";

/** Type labels by `ShippingDocumentKind` value. */
export const DOCUMENT_KIND_LABELS: Record<string, string> = {
  MANIFEST: "Manifest",
  BILL_OF_LADING: "Bill of Lading",
};

const BILL_OF_LADING = "BILL_OF_LADING";

/** A bill with no printed number is stored under a generated `NO-NUMBER-` value. */
export function isGeneratedDocumentNumber(value: string): boolean {
  return value.startsWith(GENERATED_DOCUMENT_NUMBER_PREFIX);
}

/** The number a reader should see: a bill's generated number reads as missing. */
export function manifestNumberLabel(row: {
  documentKind: string;
  manifestTrackingNumber: string;
}): string {
  return row.documentKind === BILL_OF_LADING &&
    isGeneratedDocumentNumber(row.manifestTrackingNumber)
    ? NO_NUMBER_ON_BILL_LABEL
    : row.manifestTrackingNumber;
}

/** A bill can have no facility. Anything else reads the name, then `fallback`. */
export function facilityLabel(
  row: { documentKind: string; facilityId?: string | null; facilityName?: string | null },
  fallback: string
): string {
  if (row.documentKind === BILL_OF_LADING && !row.facilityId) return NO_FACILITY_LABEL;
  return row.facilityName ?? fallback;
}
